import { render, staticRenderFns } from "./widgetFunnel.vue?vue&type=template&id=65cd593c&scoped=true&"
import script from "./widgetFunnel.vue?vue&type=script&lang=js&"
export * from "./widgetFunnel.vue?vue&type=script&lang=js&"
import style0 from "./widgetFunnel.vue?vue&type=style&index=0&id=65cd593c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cd593c",
  null
  
)

export default component.exports